import React from "react";
import styles from "./styles.module.css";

const Logo = () => <div className={styles.logo} />;

export default Logo;
